const regExp = /(^|=|\/)([0-9A-Za-z_-]{11})(\/|&|$|\?|#)/;
const site = document.getElementsByTagName("html")[0];
const sitehead = document.getElementsByTagName('head')[0];
const body = document.getElementsByTagName('BODY')[0];
const pageBody = document.getElementsByTagName('BODY');
const docLang = document.documentElement.lang;

const googleApiKey = "AIzaSyBnZIpXtj_QVyYrST3NchCuEsZVzVZmWBg";

export { regExp, site, sitehead, body, pageBody, docLang, googleApiKey };